import { render, staticRenderFns } from "./UpdateBenefit.vue?vue&type=template&id=896e876a"
import script from "./UpdateBenefit.vue?vue&type=script&lang=js"
export * from "./UpdateBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports